module.exports = __webpack_public_path__ + "img/Vietnam-3.21fd2cba.jpg";